export default "__VITE_ASSET__CSWoaFFO__"